import { Component, inject } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { GridService, SearchGridComponent } from '../../../../tms-shared';
import { UserService } from '../../services';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
  imports: [SearchGridComponent],
})
export class UsersComponent {
  protected readonly userService = inject(UserService);
  private readonly gridService = inject(GridService);

  protected columnDefs: ColDef[] = [
    this.gridService.text('username', $localize`Username`),
    this.gridService.text('emailAddress', $localize`Email Address`),
    this.gridService.text('firstName', $localize`First Name`),
    this.gridService.text('lastName', $localize`Last Name`),
    this.gridService.text('roles', $localize`Roles`),
    this.gridService.text('customer', $localize`Customer`),
    this.gridService.text('supplier', $localize`Supplier`),
    this.gridService.text('emailConfirmed', $localize`Email Confirmed`),
    this.gridService.text('disabledYesNo', $localize`Disabled`),
  ];
}
